var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1959.36 1734.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3373db;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #4ea9f4;\n      }\n\n      .cls-4 {\n        fill: #2d2daa;\n      }\n\n      .cls-5 {\n        fill: #4a62c6;\n      }\n\n      .cls-6 {\n        fill: #3e91e5;\n      }\n\n      .cls-7 {\n        fill: #3554b7;\n      }\n\n      .cls-8 {\n        fill: #f4c603;\n      }\n\n      .cls-9 {\n        fill: #3845b8;\n      }\n\n      .cls-10 {\n        fill: #3c51ba;\n      }\n\n      .cls-11 {\n        fill: #ffec00;\n      }\n\n      .cls-12 {\n        fill: #5775d3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1264.36,1181.8s-12.75,6.62-17.09,6.01c-3.92-.55-15.95-10.62-15.95-10.62,0,0,8.01,13.83,7.49,17.55-.63,4.54-12.1,15.48-12.1,15.48,0,0,13.48-6.36,17.22-5.84,4.52.63,15.82,10.45,15.82,10.45,0,0-6.47-12.74-5.84-17.27.52-3.73,10.44-15.77,10.44-15.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1021.11,1320.68c-5.09,16.48-72.81,16.33-78.49,0-81.58-234.39,18.36-1195.07,18.36-1195.07h41.78s90.78,960.68,18.36,1195.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1021.11,1320.68c-5.09,16.48-72.81,16.33-78.49,0-81.58-234.39,18.36-1195.07,18.36-1195.07h41.78s90.78,960.68,18.36,1195.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1002.75,125.61h-26.42c16.12,252.1,50.84,908.61-10.78,1095.58-2.83,8.59-22.8,12.28-41.92,11.49,4.77,35.23,11.01,65.09,18.99,88,5.68,16.33,73.4,16.48,78.49,0,72.43-234.39-18.36-1195.07-18.36-1195.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M937.25,1104.93c-4.85.13-8.9-3.7-9.02-8.56-1.69-67.65-2.2-136.28-1.53-204.14.48-48.72,1.28-130.27,7.04-234.1,1.1-19.79,1.94-40.97,2.84-63.4,2.31-57.77,4.91-122.95,12.91-195.41.53-4.84,4.9-8.34,9.74-7.78h0c4.8.55,8.25,4.88,7.72,9.69-7.93,71.87-10.52,136.73-12.82,194.21-.9,22.5-1.75,43.75-2.85,63.68-5.74,103.43-6.54,184.73-7.01,233.3-.67,67.66-.15,136.08,1.53,203.53.12,4.85-3.7,8.87-8.55,9h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M916.21,1271.8h131.31c14.42,0,26.12,11.7,26.12,26.12v292.04h-183.55v-292.04c0-14.42,11.7-26.12,26.12-26.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1032.46,1271.8h-33.86c9.05,7.55,14.82,18.92,14.82,31.63v252.55h-123.33v33.98h183.55v-276.98c0-22.74-18.44-41.18-41.18-41.18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1176.66,1600.15h-389.6c-9.56,0-17.31-7.75-17.31-17.31h0c0-11.84,9.6-21.44,21.44-21.44h381.33c11.84,0,21.44,9.6,21.44,21.44h0c0,9.56-7.75,17.31-17.31,17.31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1172.53,1561.4h-115.79c11.84,0,21.44,9.6,21.44,21.44h0c0,9.56-7.75,17.31-17.31,17.31h115.79c9.56,0,17.31-7.75,17.31-17.31h0c0-11.84-9.6-21.44-21.44-21.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M650.89,1724.54c-31.22,0-56.53-25.31-56.53-56.53h0c0-43.11,34.95-78.06,78.06-78.06h618.88c43.11,0,78.06,34.95,78.06,78.06h0c0,31.22-25.31,56.53-56.53,56.53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1325.53,1724.54c24.21,0,43.83-19.63,43.83-43.83v-30.23c0-33.43-27.1-60.53-60.53-60.53h-187.13c33.43,0,60.53,27.1,60.53,60.53v30.23c0,24.21-19.63,43.83-43.83,43.83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.27,1734.6c0-25.25,20.47-45.73,45.73-45.73h847.72c25.25,0,45.73,20.47,45.73,45.73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.27,1734.6c0-25.25,20.47-45.73,45.73-45.73h847.72c25.25,0,45.73,20.47,45.73,45.73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1451.45,1707.6c0-10.34-8.39-18.73-18.73-18.73h-222.71c10.34,0,18.73,8.39,18.73,18.73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M924.6,1532.39h0c-7.75,0-14.03-6.28-14.03-14.03v-188.06c0-7.75,6.28-14.03,14.03-14.03h0c7.75,0,14.03,6.28,14.03,14.03v188.06c0,7.75-6.28,14.03-14.03,14.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 628.95,
    y: 1618.05,
    width: 202.94,
    height: 22.4,
    rx: 3.19,
    ry: 3.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/Beam.4a67c676114427928ee766bafd9b1f57.svg";
export { ForwardRef as ReactComponent };